import { combineReducers } from 'redux';

import {
  SET_PAYERS_FILTERS,
  RESET_PAYERS_FILTERS,
  SET_PAYERS_GRID_SORT_CRITERIA,
} from './actionTypes';

const payersFiltersInitialState = {
  aggregatorID: '',
};

const payersGridSortCriteriaInitialState = {
  sortByColumn: '',
  sortDirection: '',
};

const payersFiltersReducer = (
  state = payersFiltersInitialState,
  { type = '', filters = { ...payersFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_PAYERS_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_PAYERS_FILTERS:
      return {
        ...state,
        ...payersFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const currentPayersGridSortCriteriaReducer = (
  state = payersGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...payersGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_PAYERS_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const payersReducer = combineReducers({
  payersFilters: payersFiltersReducer,
  payersGridSortCriteria: currentPayersGridSortCriteriaReducer,
});

export { payersReducer, payersFiltersInitialState, payersGridSortCriteriaInitialState };
